/* eslint-disable camelcase */
import _ from 'lodash';

import { initialState } from './initialState';



// ************
// PARTS
// ************
export const buildReducerParts = (
	{
		reInitStatePsqlCustomers,
		requestPsqlCustomers,
		receivePsqlCustomers,
		clearSelectedPsqlCustomers,
		setSelectedPsqlCustomers,
		addSelectedPsqlCustomer,
		removeSelectedPsqlCustomer,
		setLoadPsqlCustomersErrorMessage,
		clearLoadPsqlCustomersErrorMessage
	},
	filtersStatePropKey,
	filterStatePropKey = 'psqlcustomers'
) => {
	const KEY_filters = filtersStatePropKey;
	const KEY_filter = filterStatePropKey;

	return {
		[reInitStatePsqlCustomers]: state => {
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: { ...initialState }
				}
			};
		},

		[requestPsqlCustomers]: state => {
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						isLoading: true,
						loadErrorMessage: undefined
					}
				}
			};
		},

    [receivePsqlCustomers]: (state, { payload: { list = [] } = {} }) => {
			const newList = [...state[KEY_filters][KEY_filter].list, ...list];
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						list: newList,
						listCount: newList.length,
						isLoading: false,
						isLoaded: true
					}
				}
			};
		},

		[clearSelectedPsqlCustomers]: state => {
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						selected: [],
						selectedCount: 0
					}
				}
			};
		},

		[setSelectedPsqlCustomers]: (state, { payload: { selectedList = [] } }) => {
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						selected: selectedList,
						selectedCount: selectedList.length
					}
				}
			};
		},

		[addSelectedPsqlCustomer]: (state, { payload: { item } }) => {
			const newSelectedList = _.union(state[KEY_filters][KEY_filter].selected, [
				item
			]);

			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						selected: newSelectedList,
						selectedCount: newSelectedList.length
					}
				}
			};
		},

		[removeSelectedPsqlCustomer]: (state, { payload: { item } }) => {
			const newSelectedList = _.without(
				state[KEY_filters][KEY_filter].selected,
				item
			);
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						selected: newSelectedList,
						selectedCount: newSelectedList.length
					}
				}
			};
		},

		[setLoadPsqlCustomersErrorMessage]: (state, { payload: { message } }) => {
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						loadErrorMessage: message
					}
				}
			};
		},

		[clearLoadPsqlCustomersErrorMessage]: state => {
			return {
				...state,
				[KEY_filters]: {
					...state[KEY_filters],
					[KEY_filter]: {
						...state[KEY_filters][KEY_filter],
						loadErrorMessage: undefined
					}
				}
			};
		}
	};
};

export default {
	buildReducerParts
};
